const SvgIconRisk = (props) => (
  <svg viewBox="0 0 160 128" xmlns="http://www.w3.org/2000/svg">
    <path d="M80 9L140 114L20 114L80 9Z" fill="#29A964" />
    <ellipse cx="112.368" cy="61.1278" rx="30.4348" ry="30.3719" fill="#EFAC26" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M95.3132 35.9702L125.383 88.5918C121.437 90.4572 117.025 91.5007 112.368 91.5007C95.5597 91.5007 81.9336 77.9028 81.9336 61.1288C81.9336 50.6619 87.2393 41.4316 95.3132 35.9702Z"
      fill="#F2D6BB"
    />
  </svg>
);

export default SvgIconRisk;
